import { gql } from "apollo-boost"

export const getBeneficiariesToExport = gql`
query getAllBeneficiaries {
  Beneficiaries {
    projectBeneficiaries{
      	 id
      folio
      name
      lastName
      maidenName
      gender
      birthdate
      curp
      phone
      state
      municipality
      colony
    }
  }
}
`